import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'jaeger_gk',
} as IModuleProps;
